import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './MobileFooter.scss';
import LinkedInIcon from '../LinkedInIcon/LinkedInIcon';
import InstagramIcon from '../InstagramIcon/InstagramIcon';
import FacebookIcon from '../FacbookIcon/FacebookIcon';
import TwitterIcon from '../TwitterIcon/TwitterIcon';

const MobileFooter = (props) => {
    const content = useSelector((state) => state.content.pages.contact);
    
    if(typeof content != "undefined") {
        return (
            <div className="mobile-footer mobile-footer-show">
                <div className="mobile-footer-container">
                    <div className="corporate-logos">
                        <span>
                            <img
                                src={content.form_contact_info.marlin_logo.url}
                                alt={content.form_contact_info.marlin_logo.alt}
                            />
                        </span>
                        <span className="separator"></span>
                        <span>
                            <img
                                src={content.form_contact_info.greybrook_logo.url}
                                alt={content.form_contact_info.greybrook_logo.alt}
                            />
                        </span>
                    </div>
                    <div className="mobile-copyright">
                        &copy;{new Date().getFullYear()} Graywood. All Rights Reserved.
                    </div>
                    <div className="mobile-footer-links">
                        <span>
                            <a href="/privacy-policy" target="_blank">
                                Privacy Policy
                            </a>
                        </span>
                        <span>
                            By{' '}
                            <a href="https://www.52pick-up.com/" target="_blank">
                                52 Pick-up Inc.
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        );
    } else {
        return <div />
    }
};

export default MobileFooter;
